import { Guid } from "@shared/utils/guid.helper";
import { Contact } from "@models/common/contact";
import { EntityType } from "../common/entity-type.enum";
import { RelationshipType } from "../relationships/relationship-type.enum";
import { IndividualData } from "@models/individuals/individual-data";

export class RelationshipIndividualDto {
  relationshipId: string;
  contactId?: string;
  contact?: Contact;
  start?: Date;
  end?: Date;
  type: RelationshipType;
  individualDataOverride: IndividualData | null;
  entityId: string;
  entityName: string;
  entityNumber: string;
  relatedToEntityType?: EntityType;
  individualId?: string;
  name: string;

  constructor(init: Partial<RelationshipIndividualDto> = {}) {
    this.relationshipId = init.relationshipId ?? Guid.EmptyGuid;
    this.contactId = init.contactId;
    this.contact = init.contact;
    this.start = init.start;
    this.end = init.end;
    this.type = init.type!;
    this.individualDataOverride = init.individualDataOverride ? new IndividualData(init.individualDataOverride) : null;
    this.entityId = init.entityId ?? Guid.EmptyGuid;
    this.entityName = init.entityName ?? "";
    this.entityNumber = init.entityNumber ?? "";
    this.relatedToEntityType = init.relatedToEntityType;
    this.individualId = init.individualId;
    this.name = init.name ?? "";
  }

  get isResigned(): boolean {
    return this.end != undefined && new Date(this.end) < new Date();
  }
}
